import { Track } from '../../classes/track'
import { IColumnHeader } from '../../constants'

const template: string = `<!DOCTYPE html>
<html>
  <head>
    <meta charset="UTF-8">
    <title>Generated by rekordcloud</title>
    <link href="https://fonts.googleapis.com/css?family=Lato" rel="stylesheet">
    <style>
      html {
        font-family: 'Lato', sans-serif;
      }

      th {
        text-align: left;
        padding: 2px 10px;
      }

      td {
        padding: 4px 10px;
        vertical-align: top;
      }

      td:first-child {
        max-width: 400px;
      }

      tr:nth-child(even) {
        background: #eee;
      }

      @media print {
        html {
          font-size: 12px;
        }

        td:first-child {
          max-width: 300px;
        }
      }
    </style>
  </head>
  <body>
    <table>
      <thead>
        {{headers}}
      </thead>

      <tbody>
        <tr>
          {{tracks}}
        </tr>
      </tbody>
    </table>
  </body>
</html>`

export function tracksToHtml (tracks: Track[], columns: IColumnHeader[]) {
  let html: string = template

  let tracksString: string = ''
  let headerString: string = ''

  headerString = `<tr>${columns.filter(x => x.visible).reduce((acc, val) => acc += `<td>${val.label}</td>`, '')}</tr>`

  for (const track of tracks) {
    tracksString += `<tr>`

    for (const col of columns) {
      if (!col.visible) continue

      const val = (track as any)[col.value]

      tracksString += `<td>${val ? val.toString() : ''}</td>`
    }
    tracksString += `</tr>\n`
  }

  if (!html.includes('{{tracks}}')) throw new Error('tracks interpolation tag missing')
  if (!html.includes('{{headers}}')) throw new Error('headers interpolation tag missing')

  html = html.replace('{{headers}}', headerString)
  html = html.replace('{{tracks}}', tracksString)

  return html
}
